module.exports = __webpack_public_path__ + "static/media/python.779ff309.jpg";